// Copyright (c) 2017 Deere & Company

import MassLaborRateRequestStatusDetails from '../state/mass-labor-rates-request-details';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateListFiltered = (state, action) =>
    MassLaborRateRequestStatusDetails.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().requestFiltered, action) => {

    const actionTypes = {
        [actions.UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED]: updateListFiltered
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/reducers/requests-filtered.js